import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Cart/ShoppingCart/shoppingCart.container"
    ).then((module) => ({
        default: module.ShoppingCartContainer
    }))
);
